<template>
  <modal transition="pop-out" name="update-suppliers-group-modal" :width="350" :height="200">
    <div class="w-full">
      <form class="rounded px-8 pt-6 pb-8 mb-4" @submit.prevent>
        <el-col class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">Name</label>
          <input v-model="form.name" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Pending">
        </el-col><br>
        <el-col :gutter="50">
          <el-button @click="update" type="primary" :updating="updating">Update</el-button>
          <el-button @click="closeDialog" type="text">Close</el-button>
        </el-col>
      </form>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'SuppliersGroupUpdateForm',
  data() {
    return {
      error: false,
      updating: false,
    };
  },
  computed: {
    form() {
      return this.$store.state.InventoryModule.SuppliersGroup.suppliers_group;
    },
  },
  methods: {
    async closeDialog() {
      this.$modal.hide('update-suppliers-group-modal');
    },
    async update() {
      this.error = false;

      if (this.form.name !== '') {
        try {
          this.updating = true;
          await this.$store.dispatch('InventoryModule/SuppliersGroup/updateSuppliersGroup', {
            groupId: this.form.id, suppliersGroup: this.form,
          });
          this.$modal.hide('update-suppliers-group-modal');
          this.$notify.success({
            title: 'Success',
            message: 'Suppliers group update was successful.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }

        this.updating = false;
      } else {
        this.error = true;
      }
    },
  },
};
</script>

<style scoped>

</style>
